'use client';

import {runPendingPostAuthActions} from './actions';

type CompleteAuthOptions = {
  onSuccess?: () => void | Promise<void>;
  next?: string;
};

/**
 * Finalize an authentication (inline form or OAuth callback): drain pending
 * post-auth actions, then hand off. If `onSuccess` is given the caller controls
 * what happens next; otherwise navigate to `next`. Warn if neither is provided —
 * the user would be left on the form with nothing happening.
 */
export async function completeAuth({onSuccess, next}: CompleteAuthOptions): Promise<void> {
  await runPendingPostAuthActions();
  if (onSuccess) {
    await onSuccess();
  } else if (next) {
    window.location.href = next;
  } else {
    console.warn(
      'completeAuth: neither onSuccess nor next provided — nothing happens after authentication.',
    );
  }
}
